<template>
    <div class="intro-page">
        <div class="page-header">平台介绍</div>
        <p class="page-text">本系统立足于中医药大健康领域，定位于“大数据+人工智能”，通过采集、加工和处理中医药文献型数据，借助人工智能算法，构建中医药知识图谱，提供智能服务接口，以支持定制化知识服务和智能硬件的运作。下面对该系统的组成部分进行具体介绍：</p>
            
        <div class="page-info"> 
            <ul>
                <li class="info-list">
                    <p class="list-tit"><span class="icon"></span>中医药文献大数据：</p>
                    <div class="list-txt">
                        该模块采集和存储中医药领域的数字化文献资源，构建中医药文献大数据仓储库。进而，对方剂中药、古今医案、临床指南、名医经验、养生方法、适宜技术等各类文献型数据进行文献标注和深度加工，支持多人协作在线数据加工，同时支持基于自然语言处理、机器学习等技术的实体识别、关系抽取、内容抽取等自动化数据加工任务，建立包括语料库、知识库、知识图谱、规则库在内的“中医智库”。
                    </div>
                </li>
                <li class="info-list">
                    <p class="list-tit"><span class="icon"></span>中医药知识图谱：</p>
                    <div class="list-txt">
                        它是基于中医药文献大数据，采用实体识别、关系抽取、人工编审相结合构建的创新性知识组织系统。它是基于图数据库存储，由中医养生知识图谱、中医临床知识图谱、中药知识图谱、方剂知识图谱等一系列子领域可视化的知识图谱模块相互关联所构成的知识体系。
                    </div>
                </li>
                <li class="info-list">
                    <p class="list-tit"><span class="icon"></span>中医药知识服务：</p>
                    <div class="list-txt">
                       该模块基于统一的“中医智库”和知识服务技术架构，面向中医药领域不同专科和专题实现定制化知识服务，提供知识检索、知识浏览、知识展示、知识推荐等形式的知识服务功能。例如：中医学专业知识服务系统，治未病专业知识服务系统，脾胃病专业知识服务系统，《黄帝内经》理论研究知识服务系统。
                    </div>
                </li>
                 <li class="info-list">
                    <p class="list-tit"><span class="icon"></span>中医药智能算法服务：</p>
                    <div class="list-txt">
                      采用人工智能技术中的多种机器学习、深度学习算法，基于中医药大数据和中医药知识图谱，实现智能辅助诊疗、辅助养生、智能推荐、疗效预测等智能服务接口，从而支撑智能系统和智能硬件的运作。
                    </div>
                </li>
            </ul>
        </div>
        <introFooter></introFooter>
    </div>
</template>

<script>
import introFooter from './intro_footer.vue'
export default {
    components: {
        introFooter,
    },

}
</script>


<style lang="less"> 
    @import url('../../css/intro_page.less');  
    
</style>